<template>
  <div
    class="flex p-3 space-x-3 border rounded-lg rtl:space-x-reverse lg:p-4 lg:space-x-4"
  >
    <div class="flex-shrink-0 w-20">
      <StoreProductMedia :value="item.thumb && [item.thumb]" size="500x500" />
    </div>
    <div>
      <h3>{{ item.name }}</h3>
      <p class="text-sm text-gray-500">{{ item.description }}</p>
      <div v-if="item.file" class="mt-3">
        <VyButton
          :loading="loading"
          color="primary"
          theme="solid"
          shape="rounded"
          size="lg"
          :label="$t('load_more')"
          @click="loadMore()"
        />

        <VyButton
          color="primary"
          theme="solid"
          shape="rounded"
          size="md"
          :href="item.file.url"
          :icon="item.isUrl ? 'MdiOpenInNew' : 'MdiDownload'"
          target="_blank"
          :label="item.isUrl ? 'View' : 'Download'"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
